<template>
  <div class="pa-3 legal-entity">
    <v-card class="card pa-4 " color="gray10" flat>
      <v-stepper v-model="step" class="custom-stepper">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            <div
              class="custom-stepper-step"
              :class="{ 'active-step': step >= 1 }"
            >
              1
            </div>
            <span> {{ $t("corporateAccount.manage.createLegalAccount") }}</span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2">
            <div
              class="custom-stepper-step"
              :class="{ 'active-step': step >= 2 }"
            >
              2
            </div>
            <span>{{
              $t("corporateAccount.manage.create.step1.uploadDocuments")
            }}</span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">
            <div
              class="custom-stepper-step"
              :class="{ 'active-step': step >= 3 }"
            >
              3
            </div>
            <span>{{
              $t("corporateAccount.manage.create.step1.reviewDocuments")
            }}</span>
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </v-card>

    <div class="mt-4">
      <Step1 v-if="step == 1" @nextStep="nextStep" />
      <Step2 v-if="step == 2" @nextStep="nextStep" />
      <Step3 v-if="step == 3" />
    </div>
  </div>
</template>

<script>
// import CompanyInformation from "@/components/LegalEntityCreate/CompanyInformation.vue";
import Step1 from "@/components/LegalEntityCreate/Step1.vue";

import Step2 from "@/components/LegalEntityCreate/Step2.vue";

import Step3 from "@/components/LegalEntityCreate/Step3.vue";

export default {
  components: { Step1, Step2, Step3 },
  data() {
    return {
      step: this.$route.query.step || 1
    };
  },
  methods: {
    nextStep(step, CA_ID) {
      this.step = step;
      this.$router.push({ query: { step, CA_ID } });
    }
  }
};
</script>
